import { parseAsStringEnum, useQueryState } from 'nuqs';
import { FEATURE_FLAGS } from '~/constants';
import { useFeatureFlag } from '~/hooks/useFeatureFlag';

export type ViewType = 'list' | 'stacked' | 'card';

export const VIEW_TYPE: Record<ViewType, ViewType> = {
  list: 'list',
  stacked: 'stacked',
  card: 'card',
};

export const useActiveView = () => {
  const isCardViewEnabled = useFeatureFlag(FEATURE_FLAGS.foamCollapsedView);
  const [activeView, setActiveView] = useQueryState(
    'view',
    parseAsStringEnum<ViewType>([
      VIEW_TYPE.list,
      VIEW_TYPE.stacked,
      VIEW_TYPE['card'],
    ]).withDefault(
      isCardViewEnabled === 'enabled' ? VIEW_TYPE['card'] : VIEW_TYPE.stacked,
    ),
  );

  return { activeView, setActiveView };
};
